<template>
  <div class="mr-3">
    <v-menu
      transition="scale-transition"
      class="wishlit-menu-wrap"
      max-width="300"
      min-width="300"
      offset-y
      light
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="wishlist-btn"
          fab
          dark
          small
          color="accent"
          v-on="on"
          placement="bottom"
          :title="data.WishList_Tootltip_Label"
        >
          <v-badge right large color="accent">
            <template>
              <!-- <template  v-if="wishlist.length > 0"> -->
              <span slot="badge">{{wishlist.length}}</span>
            </template>
            <v-icon dark>favorite</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <div class="text-center white pa-6" v-if="wishlist == ''">
        <v-icon size="31" class="accent--text">shopping_cart</v-icon>
        <h5>{{whishlistSection.No_Products_Label}}</h5>
      </div>
      <div v-else class="wishlist-menu white">
        <emb-perfect-scrollbar class="scroll-area" style="max-height:280px">
          <v-list
            class="wishlist-cart-items py-0"
            v-for="(wishlist, index) in wishlist"
            :key="index"
          >
            <v-layout row wrap align-center cart-item ma-0>
              <v-flex sm12 md12 lg12 xl12 pa-0>
                <v-layout row wrap align-center ma-0>
                  <v-flex xs3 sm3 md3 lg3 xl3 pa-0>
                    <router-link :to="detailPage(wishlist.More_details_page_link)">
                      <img :src="wishlist.Product_Image_626_x_800px" width="60" height="77" />
                    </router-link>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 pa-0>
                    <div class="pl-1">
                      <router-link :to="detailPage(wishlist.More_details_page_link)">
                        <h6 class="mb-0 word-wrap-break">{{wishlist.Name}}</h6>
                      </router-link>
                      <span>
                        <!-- <emb-currency-sign></emb-currency-sign> -->
                        {{$n(wishlist.sellingPrice/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                        <!-- {{$n((wishlist.sellingPrice / selectedCurrency.currencyRate))}} -->
                      </span>
                    </div>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xl4 text-center pa-0 cart-action>
                    <v-btn
                      class="primary d-inline-block"
                      icon
                      @click="deleteProductFromWishlist(wishlist)"
                    >
                      <v-icon>fa fa-minus</v-icon>
                    </v-btn>
                    <!-- <v-btn
                      class="primary d-inline-block ml-2 d-inline-flex align-items-center"
                      icon
                      to="/cart"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>-->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-list>
        </emb-perfect-scrollbar>
        <!-- <emb-delete-confirmation
          ref="deleteConfirmationDialog"
          message="Are you sure you want to delete this product?"
          @onConfirm="onDeleteProductFromWishlist"
        ></emb-delete-confirmation>-->
        <v-layout align-center pa-3>
          <v-btn
            class="accent white--text"
            block
            @click="addAllWishlistItemToCart"
          >{{whishlistSection.Add_To_Cart_Button_Label}}</v-btn>
        </v-layout>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
export default {
  components: {
    embPerfectScrollbar: VuePerfectScrollbar,
  },
  props: ["data"],
  data() {
    return {
      whishlistSection: "",
      selectDeletedProduct: null,
      settings: {
        maxScrollbarLength: 160,
      },
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  computed: {
    ...mapGetters(["wishlist", "cart", "selectCurrency", "selectedLocale"]),
    /**
     * method for claculating total price
     */
    getTotalPrice() {
      let totalPrice = 0;
      if (this.wishlist.length > 0) {
        for (const item of this.wishlist) {
          totalPrice += item.total;
        }
        return totalPrice.toFixed(2);
      } else {
        return totalPrice;
      }
    },
  },
  methods: {
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        // url = url.split(" ").join("-");
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
    addAllWishlistItemToCart() {
      this.$store.dispatch("addAllWishlistItemToCart");
    },
    deleteProductFromWishlist(product) {
      //   this.$refs.deleteConfirmationDialog.openDialog();
      //   this.selectDeletedProduct = product;
      //   Vue.$toast.success(
      //     this.cmsRequestFunctions.getValidationMsgByCode("M024")
      //   );
      this.$snotify.success(
        this.cmsRequestFunctions.getValidationMsgByCode("M024"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        }
      );
      this.$store.dispatch("onDeleteProductFromWishlist", product);
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "30 WhishList/30 WhishList/30 WhishList.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var whishlistArea = self.cmsRequestFunctions.pluck(
              "WhishList_Section",
              res.area_List
            );
            self.whishlistSection = self.cmsRequestFunctions.getAllMapData(
              whishlistArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>